import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { auth } from "../../config/firebase";
import { clearAuthLocalMirror } from "../../utils/authLocalStorage";
import { isAdminTwoFaTrustOk } from "../../constants/adminSession";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/" replace />;

  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  // Admin email-code session — valid for 48h after last successful code (same email)
  if (user?.permissions === "admin" && !isLocalhost) {
    if (!isAdminTwoFaTrustOk(user?.email || "", user)) {
      auth.signOut();
      clearAuthLocalMirror();
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
